var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './index.scss';
import { arrayOf, bool, func, node, oneOfType, string } from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';
const Modal = (_a) => {
    var { visible, onHide, children, className } = _a, rest = __rest(_a, ["visible", "onHide", "children", "className"]);
    Modal.propTypes = {
        children: oneOfType([
            arrayOf(node),
            node,
        ]),
        className: string,
        visible: bool.isRequired,
        onHide: func,
    };
    const escFunction = useCallback((event) => {
        if (event.keyCode === 27 && onHide) {
            onHide();
        }
    }, [onHide]);
    useEffect(() => {
        document.addEventListener('keydown', escFunction, false);
        return () => {
            document.removeEventListener('keydown', escFunction, false);
        };
    }, [escFunction]);
    const handleOverlayClose = (e) => {
        if (e.target === e.currentTarget && onHide) {
            onHide();
        }
    };
    if (!visible) {
        return null;
    }
    const modalContainer = document.getElementById('modal-portal-container');
    const modal = (React.createElement("div", Object.assign({ className: `rg-modal-overlay ${className}`, onClick: (e) => handleOverlayClose(e) }, rest),
        React.createElement("div", { className: 'rg-modal' },
            onHide && React.createElement("div", { className: 'rg-modal-close', "data-public": true, onClick: () => onHide() },
                React.createElement("i", { className: 'fa fa-times-circle' }),
                "\u00A0Close"),
            children)));
    return createPortal(modal, modalContainer);
};
const Header = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    Header.propTypes = {
        children: oneOfType([
            arrayOf(node),
            node,
        ]),
    };
    return React.createElement("div", Object.assign({ className: 'rg-modal-header' }, rest), children);
};
const Body = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    Body.propTypes = {
        children: oneOfType([
            arrayOf(node),
            node,
        ]),
    };
    return React.createElement("div", Object.assign({ className: 'rg-modal-body' }, rest), children);
};
const Footer = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    Footer.propTypes = {
        children: oneOfType([
            arrayOf(node),
            node,
        ]),
    };
    return React.createElement("div", Object.assign({ className: 'rg-modal-footer' }, rest), children);
};
Modal.Header = Header;
Modal.Body = Body;
Modal.Footer = Footer;
export default Modal;
